export default __webpack_public_path__ + "static/media/clock-icon.aebdf19d.svg";